exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.domain-hint[data-v-c3de2e6e]{margin-bottom:12px;color:#777;font-size:.9em\n}\n.domain-input[data-v-c3de2e6e]{width:100%\n}\n.domain-preview[data-v-c3de2e6e]{margin-top:10px;font-size:.85em;color:#555;word-break:break-all\n}\n.domain-label[data-v-c3de2e6e]{font-weight:600\n}\n.domain-example[data-v-c3de2e6e]{background:#f4f4f4;border-radius:3px;padding:2px 6px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-c3de2e6e","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/distribution/form-components/PlayerSettingsForm.vue
// module id = 140
// module chunks = 0